/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import FocusServiceCard from "../../cards/FocusServiceCard";

const WhatsIncludedExcluded = ({
  includesList,
  excludesList,
  whatsincludedDesc,
  whatsincludedTitle,
  whatsnotincludedDesc,
  whatsnotincludedSubtitle,
  whatsnotincludedTitle
}) => {
  const breakpoint = useBreakpoint();

  return (
    <>
      <section className="w-full mr-auto md:!pr-4 border-t border-gray-generic planet:border-gray-standard planet:md:border-gray-light">
        <div className="pt-8 md:pt-12 md:pb-4">
          <h6
            className="font-light text-generic-text planet:font-bold text-xl md:text-xlrg-sm planet:!text-white"
            dangerouslySetInnerHTML={{ __html: whatsincludedTitle }}
          />
        </div>

        {includesList?.length > 0 && (
          <div className="grid gap-2 grid-cols-1 sm:grid-cols-3 md:grid-cols-5 py-8">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={2.25}
              spaceBetween={10}
              centeredSlides={false}
              className="h-full w-full"
            >
              {includesList &&
                includesList.length > 0 &&
                includesList.map((include, index) => (
                  <FocusServiceCard
                    key={index}
                    title={include.title}
                    description={include.description}
                    containerClass="group relative max-w-sm rounded-lg gvi-fservice-card h-full"
                    className="border border-gray-generic bg-secondary-bg p-4 planet:gvi-black-menu planet:border-gray-generic"
                    contentClass="flex flex-col h-full"
                    titleClass="w-full h-16 text-generic-text planet:!text-white planet:!font-bold xxs:font-body xxs:font-bold xxs:text-xs pb-2"
                    descriptionClass="text-generic-text planet:text-gray-generic xxs:text-xs"
                  />
                ))}
            </ConditionalSwiper>
          </div>
        )}

        {whatsnotincludedTitle && (
          <div className="pb-5">
            <h6
              className="font-light text-generic-text planet:font-bold text-xl md:text-xlrg-sm planet:!text-white"
              dangerouslySetInnerHTML={{ __html: whatsnotincludedTitle }}
            />
          </div>
        )}

        {whatsnotincludedDesc && (
          <div
            className="pb-5 text-mob md:text-base text-generic-text planet:text-gray-generic"
            dangerouslySetInnerHTML={{ __html: whatsnotincludedDesc }}
          />
        )}

        {whatsnotincludedSubtitle && (
          <div
            className="font-alice planet:font-body text-generic-text planet:text-gray-generic font-light text-[19px] md:text-xl"
            dangerouslySetInnerHTML={{ __html: whatsnotincludedSubtitle }}
          />
        )}

        {excludesList?.length > 0 && (
          <div className="grid gap-2 grid-cols-1 md:grid-cols-5 py-8">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={2.25}
              spaceBetween={10}
              centeredSlides={false}
              className="h-full w-full"
            >
              {excludesList &&
                excludesList.length > 0 &&
                excludesList.map((exclude, index) => (
                  <FocusServiceCard
                    key={index}
                    title={exclude.title}
                    description={exclude.description}
                    containerClass="group relative max-w-sm rounded-lg gvi-fservice-card"
                    className="h-full border border-gray-generic/70 bg-gray-quaternary/50 p-4 planet:ingo-program-excludes-simple-card"
                    contentClass="flex flex-col h-full"
                    titleClass="w-full h-16 text-yellow-standard xxs:font-body planet:xxs:text-gray-decimal planet:xxs:font-bold xxs:text-xs xxs:pb-2"
                    descriptionClass="text-yellow-standard planet:xxs:text-gray-decimal planet:xxs:font-light xxs:text-xs"
                  />
                ))}
            </ConditionalSwiper>
          </div>
        )}
      </section>
    </>
  );
};

export default WhatsIncludedExcluded;
